import { register } from 'register-service-worker';
import { markPwaUpdateAvailable, requestPwaUpdateCheck } from '@/utils/pwa';
import { preloadCriticalRouteChunks } from '@/router';

const CRITICAL_CHUNKS_PRELOADED_KEY = 'ewu-pwa-critical-chunks-v2';

async function preloadCriticalChunksWhenOnline() {
  if (process.env.NODE_ENV === 'production' || !navigator.onLine) return;

  try {
    if (localStorage.getItem(CRITICAL_CHUNKS_PRELOADED_KEY) === 'done') return;
    const results = await preloadCriticalRouteChunks();
    if (results.some((result) => result.status === 'rejected')) {
      console.warn('Some critical PWA routes could not be precached yet.');
      return;
    }
    localStorage.setItem(CRITICAL_CHUNKS_PRELOADED_KEY, 'done');
  } catch (error) {
    // El arranque no debe bloquearse si una ruta opcional falla al precargar.
    console.warn('Unable to precache critical PWA routes:', error);
  }
}

// El build de producción usa el Service Worker generado por Workbox. En
// desarrollo Vue CLI no genera ese archivo, pero el PWA instalado en
// localhost también debe poder arrancar si se detiene `npm run serve`.
// `public/dev-service-worker.js` proporciona un shell cacheable para ese caso.
const serviceWorkerFile = process.env.NODE_ENV === 'production'
  ? 'service-worker.js'
  : 'dev-service-worker.js';

if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  register(`${process.env.BASE_URL}${serviceWorkerFile}`, {
    async registered(registration) {
      await requestPwaUpdateCheck(registration);
    },
    async ready(registration) {
      await requestPwaUpdateCheck(registration);
      // `ready` se dispara cuando el worker ya puede interceptar las
      // peticiones. Así los chunks de las vistas críticas pasan por él y
      // quedan disponibles aunque después se detenga localhost:8080.
      void preloadCriticalChunksWhenOnline();
    },
    updated(registration) {
      markPwaUpdateAvailable(registration);
    },
    error(error) {
      console.error('Service worker registration failed:', error);
    },
  });
}
